export default {
  // Navigation
  nav_home: "首页",
  nav_products: "产品展示",
  nav_about: "公司介绍",
  nav_support: "支持与服务",
  nav_contact: "联系方式",

  // Hero Section
  hero_title: "泰山乐器",
  hero_subtitle: "中国制造名牌乐器",
  hero_description: "自1987年以来，专注于高品质管乐器制造",
  hero_cta: "探索产品",

  // Products Section
  products_title: "产品展示",
  products_subtitle: "专业管乐器，匠心制造",
  product_trumpet: "小号系列",
  product_trumpet_desc: "专业级铜管乐器，音色明亮饱满，适合各类演奏场合",
  product_trombone: "长号系列",
  product_trombone_desc: "滑动流畅，音域宽广，专业乐团首选",
  product_saxophone: "萨克斯系列",
  product_saxophone_desc: "音色圆润优美，适合爵士乐和古典音乐演奏",
  product_horn: "圆号系列",
  product_horn_desc: "音色柔和温暖，交响乐团必备乐器",
  product_clarinet: "单簧管系列",
  product_clarinet_desc: "木管乐器经典之作，音色清澈动人",
  product_flute: "长笛系列",
  product_flute_desc: "音色清脆悠扬，适合独奏和合奏",
  view_details: "查看详情",

  // Product Catalog
  catalog_title: "产品图册下载",
  catalog_description: "下载完整的泰山乐器产品图册，了解更多产品详情和规格参数",
  catalog_download: "下载图册",

  // About Section
  about_title: "公司介绍",
  about_subtitle: "三十余年匠心传承",
  about_heading: "关于泰山乐器",
  about_p1: "山东泰山管乐器制造有限公司成立于1987年，是中国领先的专业管乐器制造商。公司位于山东省，拥有现代化的生产基地和专业的研发团队。",
  // Escape the inner double quotes
  about_p2: "2004年，公司产品获文化部乐器质量监督检验中心检测后，全部符合国家标准。2006年，公司成功申报成为直接面审单位，并荣获\"中国乐器行业强势企业\"称号。",
  about_p3: "公司通过ISO9001质量体系认证和ISO14001环境体系认证，产品远销全球多个国家和地区，深受音乐爱好者和专业演奏家的信赖。",
  about_year: "成立年份",
  about_series: "产品系列",

  // Timeline
  timeline_title: "发展历程",
  timeline_1987: "公司成立，开始专注于管乐器制造",
  timeline_2001: "成为中国国际乐器展览会会员单位",
  timeline_2004: "产品通过文化部乐器质量监督检验中心检测，符合国家标准",
  // Escape inner quotes
  timeline_2006: "荣获\"中国乐器行业强势企业\"称号",
  timeline_2013: "泰山牌管乐器大满贯成为与国际著名管乐器品牌同台竞技的中国品牌",
  // Escape inner quotes
  timeline_2019: "山东省科学技术厅授予\"专精特新\"中小企业称号",

  // Support Section
  support_title: "支持与服务",
  support_subtitle: "专业的售后服务体系",
  support_quality: "质量保证",
  support_quality_desc: "通过ISO9001质量体系认证，每件产品都经过严格检测",
  support_service: "售后服务",
  support_service_desc: "专业的售后服务团队，提供维修保养咨询",
  support_maintenance: "维修保养",
  support_maintenance_desc: "提供专业的乐器维修和保养服务",
  support_guide: "使用指导",
  support_guide_desc: "提供详细的使用说明和保养指南",

  // FAQ
  faq_title: "常见问题",
  faq_q1: "如何选择适合自己的管乐器？",
  faq_a1: "建议根据您的演奏水平、音乐风格和预算来选择。初学者可以选择入门级产品，专业演奏者可以选择高端系列。我们的客服团队可以为您提供专业建议。",
  faq_q2: "产品保修期是多久？",
  faq_a2: "我们的产品提供一年质保服务，在正常使用情况下出现的质量问题，我们将免费维修或更换。",
  faq_q3: "如何保养管乐器？",
  faq_a3: "建议每次使用后清洁乐器内部，定期上油保养活塞和滑管，避免碰撞和极端温度环境。详细保养指南请参考产品说明书。",
  faq_q4: "是否提供国际配送？",
  faq_a4: "是的，我们的产品销往全球多个国家和地区。具体配送方式和费用请联系我们的销售团队。",

  // Contact Section
  contact_title: "联系方式",
  contact_subtitle: "我们期待与您交流",
  contact_info: "联系信息",
  contact_address: "公司地址",
  contact_address_value: "中国山东省",
  contact_phone: "联系电话",
  contact_phone_value: "+65 91791835",
  contact_whatsapp: "WhatsApp",
  contact_whatsapp_value: "+65 91791835",
  contact_whatsapp_button: "通过 WhatsApp 沟通",
  contact_email: "电子邮箱",
  contact_email_value: "请通过表单留言，我们会尽快回复",
  contact_hours: "工作时间",
  contact_hours_value: "周一至周五 9:00-18:00",
  contact_form_title: "在线留言",
  contact_form_name: "姓名",
  contact_form_email: "邮箱",
  contact_form_phone: "电话",
  contact_form_message: "留言内容",
  contact_form_submit: "提交留言",
  contact_form_name_placeholder: "请输入您的姓名",
  contact_form_email_placeholder: "请输入您的邮箱",
  contact_form_phone_placeholder: "请输入您的电话",
  contact_form_message_placeholder: "请输入您的留言（最多500字）",
  contact_form_required: "必填",
  contact_form_success: "提交成功！我们会尽快与您联系。",
  contact_form_error: "提交失败，请稍后重试。",
  contact_form_validate_required: "请填写所有必填项",
  contact_form_validate_email: "请输入有效的邮箱地址",
  contact_form_validate_message: "留言内容不能超过500字",

  // Footer
  footer_description: "专注于高品质管乐器制造，为音乐爱好者和专业演奏家提供优质产品。",
  footer_quick_links: "快速链接",
  footer_contact_us: "联系我们",
  footer_address: "地址：中国山东省",
  footer_hours: "工作时间：周一至周五 9:00-18:00",
  footer_copyright: "版权所有。",
  footer_powered: "技术支持 Readdy"
};
